// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"df64d2d9","148":"27eb06fb","188":"8b4ccb53","397":"b8052bb9","423":"ae8c25bb","459":"37d25261","482":"5ce66e2a","597":"de6f4d14","659":"f86da3ba","699":"19726555","762":"fc6d2205","768":"ff446701","860":"37867cfe","935":"ae0ea85c","939":"cc68c01a","962":"b81dd43c"}[chunkId] + ".chunk.js";
};